const NAME = "POSITION_GROUPS_FOR_EVALUATIONS";

export default NAME;
